export default "__VITE_ASSET__5ACC9sZt__"